import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { ITerminalUser } from '../../models/user.model';

export interface ITenantService {
  getUsersInCurrentTenant(): Observable<ITerminalUser[]>;
}

@Injectable()
export class TenantService implements ITenantService {
  readonly authBaseUrl = environment.apiAuthUri;

  constructor(private http: HttpClient) {}

  getUsersInCurrentTenant(): Observable<ITerminalUser[]> {
    const url = `${this.authBaseUrl}/api/terminal/users`;
    return this.http.get<ITerminalUser[]>(url);
  }
}
